import React, { Component } from 'react'
import PageTransition from 'gatsby-plugin-page-transitions'

import HomePage from '../components/HomePage/HomePage'

class IndexPage extends Component {
	render() {
		return (
      <PageTransition>
			 <HomePage {...this.props} />
      </PageTransition>
		)
	}
}
export default IndexPage
export const query = graphql`
query HomePageQuery {
  markdownRemark(frontmatter: {id: {eq: "home"}}) {
    frontmatter {
      title
      description
      video {
        name
        src {
          publicURL
        }
      }
      map {
        bgImage {
          childImageSharp {
            sizes(maxWidth: 1440) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        bgPageImage {
          childImageSharp {
            sizes(maxWidth: 1000) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        places {
          title
          caption
          href
          enabled
          position {
            x
            y
          }
          image {
            childImageSharp {
              resolutions(width: 200, height: 200) {
               ...GatsbyImageSharpResolutions_noBase64
              }
            }
          }
        }
      }      
    }
  }
}
`


// WEBPACK FOOTER //
// ./src/pages/index.js